import React, {useState} from "react";
import {Divider, Form, Input, Select} from "antd";
import licenceValidation from "../licenceValidation";

const {Option} = Select;

const FirstStepChooseCompanyAndProduct = ({
                                              licenceSavePending, availableCompanies, companyPreviouslyAddedProducts, availableSoftwareProducts,
                                              licenceElements,
                                              onCompanyChange, companySelected, onProductsChange, darkMode
                                          }) => {

    const [codeDisabled, setCodeDisabled] = useState(!companySelected || true);

    const disabledCompanyChange = licenceElements.length;

    return <>
        <Divider orientation="left">Licence Element</Divider>

        <Form.Item name='companyId' label='Company' readOnly={licenceSavePending}
                   rules={licenceValidation.company}>
            <Select showSearch style={{width: '100%'}} placeholder={"Select Company"} onChange={onCompanyChange}
                    disabled={disabledCompanyChange}
                    optionFilterProp="children"
                    dropdownClassName={darkMode && 'dark-mode'}
            >
                {
                    availableCompanies.map(({id, value}) => (
                        <Option key={id} value={id}>{value}</Option>))
                }
            </Select>
        </Form.Item>

        <Form.Item name='softwareProductWrapper' label='Software Product' readOnly={licenceSavePending}>

            <Form.Item readOnly={licenceSavePending}
                       name="softwareProductId"
                       rules={licenceValidation.softwareProduct}
                       style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
            >
                <Select disabled={!companySelected || disabledCompanyChange} style={{width: '100%'}}
                        placeholder={"Select Software Product"}
                        dropdownClassName={darkMode && 'dark-mode'}
                        options={[
                            {
                                label: "Existing Products",
                                options: companyPreviouslyAddedProducts.map(({softwareProductId, id, value, code}) =>
                                    ({id: softwareProductId, value: code, companyHasSoftwareProductId: id}))
                            },
                            {
                                label: "Add new Product",
                                options: availableSoftwareProducts.map(({id, value}) => ({id, value}))
                            }
                        ]}
                        onChange={(ignore, selectedProduct) => {
                            const {companyHasSoftwareProductId, id, value} = selectedProduct;

                            if (companyHasSoftwareProductId) {
                                setCodeDisabled(true);
                                onProductsChange(id, selectedProduct, value);
                            } else {
                                onProductsChange(id, selectedProduct);
                                setCodeDisabled(false);
                            }
                        }}/>

            </Form.Item>
            <Form.Item
                name="code"
                rules={licenceValidation.code}
                style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
            >
                <Input placeholder="Product Name" disabled={codeDisabled}/>
            </Form.Item>


        </Form.Item>
    </>;
};

export default FirstStepChooseCompanyAndProduct;